import { useEffect, useState } from "react";
import { getArrayIsNotEmpty } from "../../../SharedComponents/utils/helpers/getArrayIsNotEmpty";
import { getFormatedCarName } from "../../utils/helpers/userCarHelpers/getFormatedCarName";

const UserCarImageVisualizer = ({
    carMake,
    images
}) => {
    const isNotEmpty = getArrayIsNotEmpty(images);

    const [selectedImage, setSelectedImage] = useState(null);

    const getFallbackMakeLogoImage = () => {
        const preparedCarMake = getFormatedCarName(carMake);
        const imageExtension = "png";

        //Must use context because of dynamic import of local images
        const getImage = require.context(
            '../../../SharedComponents/assets/images/car-brand-logos',
            false,
            /\.(png)$/
        );

        const Image = getImage(`./${preparedCarMake}.${imageExtension}`);

        return Image;
    };

    useEffect(() => {

        if (isNotEmpty) {
            const firstImage = images[0];
            setSelectedImage(firstImage);
        }

        else {
            const image = getFallbackMakeLogoImage();
            setSelectedImage(image);
        };
    }, []);


    if (selectedImage === null) {
        return null;
    };


    const GetOtherImageComponent = (image, index) => {

        const handleClick = () => {
            setSelectedImage(image);
        };

        return (
            <div
                key={index}
                onClick={() => handleClick()}
                style={styles.smallImageContainer}
            >
                <img
                    src={image}
                    style={styles.smallImageStyle}
                />
            </div>
        );
    };

    const getSelectedImageStyle = () => {
        if (isNotEmpty) {
            return styles.selectedImageContainer;
        }

        else {
            return styles.selectedLogoImageContainer
        };
    };

    return (
        <div>
            <div style={getSelectedImageStyle()}>
                <img
                    src={selectedImage}
                    style={styles.selectedImageStyle}
                />
            </div>

            {isNotEmpty && (
                <div style={styles.smallImagesRow}>
                    {images.map((image, index) => {
                        return GetOtherImageComponent(image, index);
                    })}
                </div>
            )}

        </div>
    );
};


export default UserCarImageVisualizer;

const styles = {
    selectedImageContainer: {
        width: 300,
        height: 300,
        border: "1px solid #CBD5E1",
        borderRadius: 8,
    },
    selectedLogoImageContainer: {
        width: 300,
        height: 300,
        border: "1px solid #CBD5E1",
        borderRadius: 8,
        background: "linear-gradient(to bottom, transparent 50%, rgba(0,0,0,0.7) 100%)"
    },
    selectedImageStyle: {
        width: "100%",
        height: "100%",
        objectFit: "cover",
        borderRadius: 8
    },
    smallImagesRow: {
        marginTop: 15,
        display: 'flex',
        alignItems: 'center',
        width: 'max-content',
        gap: 10
    },
    smallImageContainer: {
        cursor: 'pointer',
        width: 75,
        height: 75,
        border: "1px solid #CBD5E1",
        borderRadius: 8,
    },
    smallImageStyle: {
        width: "100%",
        height: "100%",
        objectFit: "cover",
        borderRadius: 8
    }
}